import {
  configureStore,
  getDefaultMiddleware,
  combineReducers,
} from "@reduxjs/toolkit";
import logger from "redux-logger";
import createSagaMiddleware from "redux-saga";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

//import customizer from "../reducers/customizer/";
import navbar from "../reducers/navbar/index";
import layout from "../reducers/layout/index";
import authSlice from "../slices/authSlice";
import rootSaga from "../sagas/rootSaga";

import vehicleSlice from "../slices/vehicleSlice";
import offsiteSlice from "../slices/offsiteSlice";

const sagaMiddleware = createSagaMiddleware();

const persistConfig = {
  key: "auth",
  storage,
};

const persistedAuthReducer = persistReducer(persistConfig, authSlice);

const rootReducer = combineReducers({
  //customizer: customizer,
  navbar,
  layout,
  vehicle: vehicleSlice,
  offsite: offsiteSlice,
  authentication: persistedAuthReducer,
});

// const persistedReducer = persistReducer(persistConfig, rootReducer);

// const reducer = {
//   customizer: customizer,
//   navbar: navbar,
//   authentication: authSlice,
// };

export const store = configureStore({
  reducer: rootReducer,
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
  middleware: [
    ...getDefaultMiddleware({ thunk: true, serializableCheck: false }),
    sagaMiddleware,
    logger,
  ],
});

export const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);
